import React from 'react';
import './VacationTracker.css';

function VacationTracker({ data }) {
  const vacationData = data || [];
  const totalDays = vacationData.reduce((sum, vacation) => sum + (Number(vacation.days) || 0), 0);
  const usedDays = vacationData
    .filter(v => v.status === 'used')
    .reduce((sum, vacation) => sum + (Number(vacation.days) || 0), 0);
  const scheduledDays = vacationData
    .filter(v => v.status === 'scheduled')
    .reduce((sum, vacation) => sum + (Number(vacation.days) || 0), 0);

  return (
    <div className="vacation-tracker">
      <h3>Vacation & Time Off</h3>
      
      <div className="vacation-summary">
        <div className="vacation-stat">
          <span className="stat-label">Approved Total</span>
          <span className="stat-value">{totalDays}</span>
        </div>
        <div className="vacation-stat">
          <span className="stat-label">Used</span>
          <span className="stat-value used">{usedDays}</span>
        </div>
        <div className="vacation-stat">
          <span className="stat-label">Scheduled</span>
          <span className="stat-value scheduled">{scheduledDays}</span>
        </div>
        <div className="vacation-stat">
          <span className="stat-label">Policy Model</span>
          <span className="stat-value available">Approval-based</span>
        </div>
      </div>

      <div className="vacation-bar">
        <div className="bar-container">
          <div className="bar-segment used" style={{ flex: usedDays }}>
            {usedDays > 0 && <span className="bar-label">{usedDays}</span>}
          </div>
          <div className="bar-segment scheduled" style={{ flex: scheduledDays }}>
            {scheduledDays > 0 && <span className="bar-label">{scheduledDays}</span>}
          </div>
        </div>
      </div>

      <div className="vacation-details">
        <h4>Upcoming</h4>
        <ul>
          {vacationData.filter(v => v.status === 'scheduled').map((vacation, idx) => (
            <li key={idx}>
              <span className="date-range">
                {new Date(vacation.startDate).toLocaleDateString()} - {new Date(vacation.endDate).toLocaleDateString()}
              </span>
              <span className="duration">{vacation.days}d</span>
            </li>
          ))}
          {vacationData.filter(v => v.status === 'scheduled').length === 0 && (
            <li className="no-data">No upcoming vacation scheduled</li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default VacationTracker;
